export default "__VITE_ASSET__nZjknP5s__"